
import { GoogleGenAI } from "@google/genai";
import { Transaction } from "../types";

/**
 * Generates financial insights using Google Gemini AI based on the provided transaction history.
 * @param transactions - List of income and expense transactions.
 * @returns A promise resolving to a string of financial advice.
 */
export async function getFinancialInsights(transactions: Transaction[]) {
  if (transactions.length === 0) return "Belum ada data transaksi untuk dianalisis.";

  const summary = transactions.reduce((acc, curr) => {
    if (curr.type === 'INCOME') acc.income += curr.amount;
    else acc.expense += curr.amount;
    return acc;
  }, { income: 0, expense: 0 });

  const prompt = `
    Berikut adalah ringkasan KAS sekolah saat ini:
    - Total Pemasukan: Rp ${summary.income.toLocaleString('id-ID')}
    - Total Pengeluaran: Rp ${summary.expense.toLocaleString('id-ID')}
    - Saldo: Rp ${(summary.income - summary.expense).toLocaleString('id-ID')}
    - Jumlah Transaksi: ${transactions.length}

    Berikan 3 poin nasihat finansial singkat, profesional, dan dalam Bahasa Indonesia untuk bendahara kelas berdasarkan data ini. Fokus pada efisiensi pengeluaran dan kesehatan kas.
  `;

  try {
    // Re-initialize the AI client right before use to ensure the most current configuration is used.
    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: prompt,
    });
    
    // Access the .text property directly (do not call as a method).
    return response.text || "Gagal mendapatkan analisis dari AI.";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "Gagal memuat analisis AI.";
  }
}
